import React from 'react';
import { Collapse } from 'antd';
import { InfoCircleOutlined, CaretDownFilled, StarOutlined, PlusOutlined } from '@ant-design/icons';
import { HeatmapV2 } from '../../../../../../../../Components/HeatmapV2';
import AsyncSection from '../../../../../../../../Components/AsyncSection';
import SectionHeader from '../../../SectionHeader';
import './index.scss';
import { HEADER_TEXT, RATINGS_LEGEND, HEATMAP_KEY } from './constants';
import { getScaleConfig } from '../../../../utils/scaleConfig';




const BenchmarkHeatmap = (props) => {
    const [legendActiveKey, setLegendActiveKey] = React.useState(['0']);
    const scale = getScaleConfig(props.scaleType);
    const legend = RATINGS_LEGEND.byScale[scale.type];
    // Memoised on the scale so HeatmapV2 gets the same object until the scale
    // actually changes.
    const benchmarkStyle = React.useMemo(() => ({
        benchmarkIndex: 'All but self', // shade every cell by its distance from this
        favorableMin: scale.favorableThreshold, // scores below this get a red ▼
    }), [scale]);

    const legendHeader = (
        <div className='ratings-legend__header'>
            <span className='ratings-legend__icon-wrap'>
                <InfoCircleOutlined />
            </span>
            <span className='ratings-legend__heading'>{RATINGS_LEGEND.heading}</span>
            <span className='ratings-legend__subheading'>{legend.subheading}</span>
        </div>
    );
    const columns = props.fetchRaterHeatmapApi.data && props.fetchRaterHeatmapApi.data.columns ? props.fetchRaterHeatmapApi.data.columns : []

    const data = props.fetchRaterHeatmapApi.data && props.fetchRaterHeatmapApi.data.data ? props.fetchRaterHeatmapApi.data.data : []
    return (
        <AsyncSection api={props.fetchRaterHeatmapApi} loaderHeight={300} loaderWidth={600}>
            <SectionHeader
                title={HEADER_TEXT.title}
                description={HEADER_TEXT.description}
            />

            <Collapse
                className='ratings-legend'
                expandIconPosition="right"
                activeKey={legendActiveKey}
                onChange={setLegendActiveKey}
            >
                <Collapse.Panel header={legendHeader} key="0">
                    <div className='ratings-legend__grid' style={{ '--legend-cols': legend.scale.length }}>
                        {legend.scale.map((item) => (
                            <div className={`ratings-legend__item ratings-legend__item--${item.tone}`} key={item.value}>
                                <span className='ratings-legend__badge'>{item.value}</span>
                                <div>
                                    <div className='ratings-legend__label'>{item.label}</div>
                                    {item.range && <div className='ratings-legend__range'>{item.range}</div>}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className='ratings-legend__footnote'>{legend.footnote}</div>
                </Collapse.Panel>
            </Collapse>

        <div className='cardwrapper'>
            <h3>Heatmap</h3>
                <p className='description-container'>Mean score by category, sub-category, and behavior across stakeholder groups. Cells are shaded by distance from the row's benchmark (All but Self). Click a row to drill down.</p>



                        <HeatmapV2
                            isMultipleSheetsNeeded={true}
                            isHeaderSectionHidden={true}
                            id="heatmap-grid"
                            heatmapType={"Overall Heatmap"}
                            columns={columns}
                            childColumns={columns}
                            headers={[]}
                            selectedHeaders={[]}
                            data={data}
                            benchmarkStyle={benchmarkStyle}
                            onSelectHeader={() => { }}
                            showHeadersLoader={false}
                            showTableLoader={false}
                            showErrorState={false}
                            onExpand={() => { }}
                            selectedScoreLevel={["favourable"]}
                            scoreLevelList={[]}
                            onChangeScoreType={() => { }}
                            comparisonLevelList={[]}
                            selectedLevel={[]}
                            onChangeComparisonLevel={() => { }}
                        />
                <div className='heatmap-key'>
                    <div className='heatmap-key__row'>
                        <span className='heatmap-key__item'>
                            <span className='heatmap-key__swatch' />
                            {HEATMAP_KEY.shading}
                        </span>
                        <span className='heatmap-key__item heatmap-key__item--danger'>
                            <CaretDownFilled />
                            {HEATMAP_KEY.threshold(scale.favorableThreshold)}
                        </span>
                    </div>
                    <div className='heatmap-key__row'>
                        <span className='heatmap-key__item heatmap-key__item--critical'>
                            <StarOutlined />
                            {HEATMAP_KEY.critical}
                        </span>
                        <span className='heatmap-key__item'>
                            <PlusOutlined />
                            {HEATMAP_KEY.expand}
                        </span>
                    </div>
                </div>
        </div>
        </AsyncSection>
    );
};

export default BenchmarkHeatmap;
